import React from 'react';
import PropTypes from 'prop-types';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import SovosButtonsGroup from 's1-ui/sovos-buttons-group/SovosButtonsGroup';
import CostObjEditor from '../costObjEditor/CostObjEditor';
import {
  SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';

const initialState = {
  saveCostObjDisabled: true,
  openCostObjEditorSlidingPanel: false,
  costObj: {
    id: 0,
    name: '',
    description: '',
    entityCode: '',
    goodServiceCode: '',
    locationDtoList: [
      {
        addressLine1: '',
        addressLine2: '',
        city: '',
        costObjectId: 0,
        country: '',
        id: 0,
        locationType: '',
        state: '',
        zipCode: ''
      }
    ],
    allocationUnitDtos: [
      {
        id: 0,
        unitCount: '',
        unitCountAvailable: '',
        originalUnitCountAvailable: 0
      }
    ]
  }
};

class CostObjEditorContainer extends React.PureComponent {
  state = { ...initialState, costObjInformation: { ...initialState.costObj } };

  componentWillReceiveProps(nextProps) {
    if (this.props.fetchingCostObj && !nextProps.fetchingCostObj) {
      const costObj = nextProps.costObj;

      if (costObj.allocationUnitDtos.length === 0) {
        costObj.allocationUnitDtos = [
          ...initialState.costObj.allocationUnitDtos
        ];
      }
      this.setState({
        openCostObjEditorSlidingPanel: true,
        costObjInformation: costObj
      });
    }
  }

  handleOpenCostObjEditorSlidingPanel = () =>
    this.setState({ openCostObjEditorSlidingPanel: true });

  handleCreateCostObjClick = () => {
    this.setState({
      costObjInformation: { ...initialState.costObj },
      saveCostObjDisabled: true
    });
    this.handleOpenCostObjEditorSlidingPanel();
  };

  handleCloseCostObjEditorSlidingPanel = () => {
    this.setState({ openCostObjEditorSlidingPanel: false });
  };

  handleSave = () => {
    if (this.state.costObjInformation.id) {
      this.props.costObjsActions.updateCostObj(this.state.costObjInformation);
    } else {
      this.props.costObjsActions.createCostObj(
        {
          ...this.state.costObjInformation,
          allocationUnitDtos: [
            ...this.state.costObjInformation.allocationUnitDtos.filter(
              allocationUnit => allocationUnit.id !== 0
            )
          ]
        },
        this.props.pageState
      );
    }
    this.handleCloseCostObjEditorSlidingPanel();
  };

  isSaveButtonDisabled = state =>
    state.name === '' ||
    state.locationDtoList.findIndex(
      location =>
        location.locationId === '' ||
        location.costObjectId === '' ||
        location.addressLine1 === '' ||
        location.city === '' ||
        location.locationType === '' ||
        location.state === '' ||
        location.zipCode === ''
    ) !== -1 ||
    state.allocationUnitDtos.findIndex(allocationUnit =>
      allocationUnit.id !== 0
        ? allocationUnit.unitCount === '' ||
          allocationUnit.unitCount < 1 ||
          allocationUnit.totalCountAvailable - allocationUnit.unitCount <
            0
        : ''
    ) !== -1;

  handleCostObjFieldChange = (fieldName, value) =>
    this.setState(oldState => {
      const costObjInformation = {
        ...oldState.costObjInformation,
        [fieldName]: value
      };
      return {
        costObjInformation,
        saveCostObjDisabled: this.isSaveButtonDisabled(costObjInformation)
      };
    });

  handleLocationChange = newLocationDtoList => {
    this.setState(oldState => {
      const costObjInformation = {
        ...oldState.costObjInformation,
        locationDtoList: [...newLocationDtoList]
      };
      return {
        costObjInformation,
        saveCostObjDisabled: this.isSaveButtonDisabled(costObjInformation)
      };
    });
  };

  handleAllocationUnitChange = newAllocationUnitDtos => {
    this.setState(oldState => {
      const costObjInformation = {
        ...oldState.costObjInformation,
        allocationUnitDtos: [...newAllocationUnitDtos]
      };
      return {
        costObjInformation,
        saveCostObjDisabled: this.isSaveButtonDisabled(costObjInformation)
      };
    });
  };

  render() {
    return (
      <div>
        <SovosButtonsGroup
          align="right"
          style={ { marginTop: 25, marginBottom: 15 } }
        >
          <SovosRaisedButton onClick={ this.handleCreateCostObjClick }>
            NEW
          </SovosRaisedButton>
        </SovosButtonsGroup>
        <SovosEditableSlidingPanel
          isDirty={ () => true }
          contentStyle={ { padding: 0 } }
          open={ this.state.openCostObjEditorSlidingPanel }
          onClose={ this.handleCloseCostObjEditorSlidingPanel }
          showCloseButton={ false }
          baseWidth={ '1080px' }
          title="Cost Object Builder"
          SaveButtonProps={ {
            onClick: this.handleSave,
            disabled:
              this.state.saveCostObjDisabled || this.props.creatingCostObj,
            className: 'cost-obj-builder__button'
          } }
          CancelButtonProps={ {
            className: 'cost-obj-builder__button',
            children: 'CANCEL'
          } }
          CloseDialogProps={ {
            DialogTitleProps: {
              children: SLIDING_PANEL_DIALOG_TITLE,
              className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
            },
            DialogContentProps: {
              children: SLIDING_PANEL_DIALOG_TEXT,
              className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
            },
            OKButtonProps: {
              children: SLIDING_PANEL_DIALOG_ACTION_LABEL
            },
            CancelButtonProps: {
              children: 'CANCEL'
            }
          } }
        >
          <CostObjEditor
            onCancel={ this.handleCloseCostObjEditorSlidingPanel }
            onSave={ this.handleSave }
            costObj={ this.state.costObjInformation }
            onChangeField={ this.handleCostObjFieldChange }
            saveDisabled={ this.state.saveCostObjDisabled }
            onLocationChange={ this.handleLocationChange }
            onAllocationUnitChange={ this.handleAllocationUnitChange }
          />
        </SovosEditableSlidingPanel>
      </div>
    );
  }
}

CostObjEditorContainer.propTypes = {
  creatingCostObj: PropTypes.bool.isRequired,
  fetchingCostObj: PropTypes.bool.isRequired,
  pageState: PropTypes.object,
  costObj: PropTypes.object,
  costObjsActions: PropTypes.shape({
    createCostObj: PropTypes.func,
    updateCostObj: PropTypes.func
  }).isRequired
};

CostObjEditorContainer.defaultProps = {
  pageState: {}
};

export default CostObjEditorContainer;



// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjEditorContainer/CostObjEditorContainer.js